import { useAuth } from '@features/auth/hooks/useAuth';

export function useIsAdmin(): boolean {
  const { user } = useAuth();

  return Boolean(user?.isAdmin);
}
